export const DEALER_LOCATOR_FORM_ID = 'dealer-locator-form';
export const USER_CONSENT_FORM_ID = 'user-consent-form';
export const CHECK_OTHER_LOCATION_FORM_ID = 'check-other-location-form';

//These constants are used because endpoint values are returning in English
export const CLOSED = 'Closed';
export const OPEN_24_HOURS = 'Open 24 hours';

export const SELECTED_STORE_ID = 'selectedStoreId';

export const DEFAULT_MAP_ZOOM = 6;
export const DEFAULT_MAP_BOUNDS = {
  north: 0,
  east: 0,
  south: 0,
  west: 0
};
export const MAP_MARKER_MIN_WIDTH = 291;
export const MAP_MARKER_MAX_WIDTH = 304;
export const MOBILE_MAP_HEIGHT_OFFSET = '282px';
export const DEFAULT_MAP_HEIGHT = '400px';
